export default "__VITE_ASSET__CgjJI2h1__"